import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router';

import { Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';

import LaunchIcon from '@mui/icons-material/Launch';

import { DialogContentStyle, DialogActionsStyle } from '../styles/DialogStyle';
import { TableTheadStyle, TablePaddingStyle } from '../styles/TableStyle';

import { BuscarActividad } from '../connections/admin/ActividadConnection';
import { ObtenerAutoridadesMaterias } from '../connections/catalogos/AutoridadConnection';
import { ObtenerMateria } from '../connections/catalogos/MateriaConnection';

import { ActividadProps } from '../interfaces/admin/ActividadInterface';
import { AutoridadProps } from '../interfaces/catalogos/AutoridadInterface';
import { MateriaProps } from '../interfaces/catalogos/MateriaInterface';

type TipoBusquedaType = '' | 'expediente' | 'exhortoRecibido' | 'numeroSeguimiento' | 'buzonElectronico';

interface Props {
    openDialog:              boolean;
    handleCloseDialog:       () => void;
}

export const DialogBuscar = ({ openDialog, handleCloseDialog }: Props ) => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState( false );

    const [referencia, setReferencia] = useState( '' );

    const [rows, setRows] = useState<ActividadProps[]>( [] );
    
    const [buscarPor, setBuscarPor] = useState<TipoBusquedaType>( 'numeroSeguimiento' );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const cerrarDialog = () => {

        setRows( [ ] );
        setBuscarPor( 'numeroSeguimiento' );
        setReferencia( '' );
        setAutoridad( 0 );
        setMateria( 0 );

        setLoading( false );     
        handleCloseDialog();
    }

    const handleBuscarActividad = async () => {       
      
        setLoading( true );
        setRows( [] );

        let tipoBusqueda = 0;

        if( buscarPor === 'numeroSeguimiento'){
            tipoBusqueda = 1;
        }
        else if( buscarPor === 'expediente'){
            tipoBusqueda = 2;
        }
        else if( buscarPor === 'exhortoRecibido'){
            tipoBusqueda = 3;
        }
        else if( buscarPor === 'buzonElectronico'){
            tipoBusqueda = 4;
        }

        await BuscarActividad({ referencia: referencia.trim(), idTipoBusqueda: tipoBusqueda, idAutoridad: autoridad }).then( resp => {         

            setTimeout(() => {
                
                setBuscarPor( 'numeroSeguimiento' );
                setReferencia( '' );
                setAutoridad( 0 );
                setMateria( 0 );

                setLoading( false );                  
                setRows( resp );                          
    
            }, 700);

        });

    }

    useEffect(() => {
        
        if( openDialog){          
            setRows( [ ] );
        }        

    }, [ openDialog]);

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerMateria().then( resp => {  
                setMateriaArray( resp );    
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){      

            await ObtenerAutoridadesMaterias( materia ).then( resp => { 
                setAutoridadArray( resp );                   
            });

        }
        
        if( materia !== 0 ){
            Obtener();        
        }

    }, [ materia ]);

    return (      

        <Dialog 
            maxWidth='md' 
            fullWidth={ true }
            open={ openDialog } 
        >

            <DialogTitle>
                Buscar                 
            </DialogTitle>
        
            <DialogContent sx={ DialogContentStyle }>

                <Grid container spacing={3} mt={1}>

                    <Grid size={{ md: 12, xs: 12 }}>

                        <FormControl>            

                            <FormLabel color='primary'>Seleccione el tipo de busqueda</FormLabel>             
                            <RadioGroup row>

                                <FormControlLabel value={1} control={ <Radio checked={ buscarPor === 'numeroSeguimiento' } onChange={ () => { setBuscarPor( 'numeroSeguimiento' ); setAutoridad(0); } } />} label='Número de Seguimiento' />
                                <FormControlLabel value={2} control={ <Radio checked={ buscarPor === 'expediente' } onChange={ () => { setBuscarPor( 'expediente' ); } } />} label='Número de Expediente' />
                                <FormControlLabel value={3} control={ <Radio checked={ buscarPor === 'exhortoRecibido' } onChange={ () => { setBuscarPor( 'exhortoRecibido' ); } } />} label='Número de Exhorto recibido' />
                                <FormControlLabel value={3} control={ <Radio checked={ buscarPor === 'buzonElectronico' } onChange={ () => { setBuscarPor( 'buzonElectronico' ); } } />} label='Folio de Búzon Electrónico' />
                               
                            </RadioGroup>

                        </FormControl>

                    </Grid>          
                    
                    <Grid size={{ md: ( buscarPor === 'expediente' || buscarPor === 'exhortoRecibido' ) ? 6 : 9, xs: 12 }} > 

                        <TextField 
                            fullWidth
                            label={ 
                                buscarPor === 'numeroSeguimiento'
                                ? 'Número de Seguimiento'     
                                : buscarPor === 'expediente'
                                ? 'Número de Expediente'     
                                : buscarPor === 'exhortoRecibido'
                                ? 'Número de Exhorto Recibido'     
                                : buscarPor === 'buzonElectronico'
                                ? 'Folio de Búzon Electrónico'     
                                : ''
                            }
                            value={ referencia }   
                            onChange={ ( e ) => { setReferencia( e.target.value.toUpperCase() ); } }    
                            slotProps={{
                                input: {
                                    autoComplete: 'off'
                                },
                                inputLabel: {
                                    shrink: true,
                                }
                            }}  
                        />

                    </Grid>  

                    {
                        ( buscarPor === 'expediente' || buscarPor === 'exhortoRecibido' )
                        &&
                            <Grid size={{ md: 6, xs: 12 }}> 

                                <FormControl>

                                    <FormLabel>Seleccione la materia</FormLabel>
                                    <RadioGroup row>
                                        {
                                            materiaArray
                                            .filter( (elem) => elem.idMateria === 5 || elem.idMateria === 6 )
                                            .map( ({ idMateria, descripcion }) => (
                                                <FormControlLabel 
                                                    key={ idMateria }
                                                    label={ descripcion }
                                                    control={ <Radio checked={ materia === idMateria } 
                                                    onChange={ () => setMateria( idMateria ) } />} 
                                                />                        
                                            ))
                                        }   
                                    </RadioGroup>

                                </FormControl>

                            </Grid>   
                    }      
                   
                    {
                        ( buscarPor === 'expediente' || buscarPor === 'exhortoRecibido' )
                        &&
                            <Grid size={{ md: 12, xs: 12 }}> 
                            
                                <FormControl fullWidth>
                                    <InputLabel>Autoridad</InputLabel>
                                
                                    <Select                                                                            
                                        label='Autoridad'
                                        value={ autoridad }                                
                                        onChange={ ( e ) => setAutoridad( e.target.value ) }
                                    >
                                        <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>     
                                        {
                                            autoridadArray.map( ({ idAutoridad, descripcion }) => ( 
                                                <MenuItem key={idAutoridad} value={idAutoridad}>{ descripcion }</MenuItem>     
                                            ))
                                        }
                                    </Select>

                                </FormControl>
                            
                            </Grid>                      
                    }             

                    <Grid size={{ md: ( buscarPor === 'expediente' || buscarPor === 'exhortoRecibido' ) ? 12 : 3, xs: 12 }} textAlign={'end'}> 
                   
                        <Button             
                            variant='contained'
                            sx={{ width: ( buscarPor === 'expediente' || buscarPor === 'exhortoRecibido' ) ? 260 : '100%' }}
                            fullWidth={ ( buscarPor === 'numeroSeguimiento' || buscarPor === 'buzonElectronico' ) }        
                            onClick={ handleBuscarActividad }                            
                            disabled={
                                (
                                    ( buscarPor === 'expediente' || buscarPor === 'exhortoRecibido' )
                                    ?
                                        referencia === '' || autoridad === 0
                                    :
                                        referencia === ''
                                ) || loading
                            }
                        >
                            Buscar
                        </Button>       

                    </Grid>
                                   
                    <Grid size={{ md: 12, xs: 12 }}>

                        <TableContainer sx={{ mt: 3, borderRadius: 3 }}>
                    
                            <Table sx={{ minWidth: 500 }}>
            
                                <TableHead sx={{ ...TableTheadStyle }}>
            
                                    <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%', fontWeight: 'bold' }}>No. Seguimiento</TableCell>
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '35%', fontWeight: 'bold' }}>Proceso (Módulo)</TableCell>     
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%', fontWeight: 'bold' }}>Usuario asignado</TableCell>
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '5%', fontWeight: 'bold' }}> </TableCell>

                                    </TableRow>

                                </TableHead>

                                <TableBody>                                     

                                    {                                       
                                        rows.map( ( { id, numeroSeguimiento, usuario, proceso, path, tipoTramite, actividad, fecha, idEstatus, estatus, usuarioActual } ) => (

                                            <TableRow key={ id } >                                                                    
                                            
                                                <TableCell>
                                                  
                                                    <Typography variant='h6' fontWeight={'bold'}>
                                                        { numeroSeguimiento }                                                     
                                                    </Typography> 

                                                    {
                                                        actividad
                                                        &&
                                                            <Typography variant='subtitle2' mt={1}>
                                                                <strong>Actividad:</strong> <br /> { actividad }                                                    
                                                            </Typography>                                                 
                                                    }                                                  
                                                  
                                                    <Typography variant='subtitle2' mt={1}>
                                                        { fecha }                                                     
                                                    </Typography>                                                 
                                                
                                                </TableCell>

                                                <TableCell> 

                                                    <Typography variant='h6' fontWeight={'bold'}>
                                                        { proceso }                                                     
                                                    </Typography> 
                                                  
                                                    <Typography variant='subtitle2' mt={1}>
                                                        { tipoTramite && ' (' + tipoTramite + ')' }                                                   
                                                    </Typography>    

                                                </TableCell>

                                                <TableCell> { usuario } </TableCell>

                                                <TableCell sx={{ textAlign: 'center' }}> 

                                                    {
                                                        idEstatus === 3
                                                        ?
                                                            <Chip 
                                                                label={ estatus } 
                                                                color='primary'                                                                
                                                            />
                                                        :
                                                            usuarioActual
                                                            &&
                                                                <IconButton
                                                                    color='primary'
                                                                    onClick={ () => navigate( path ) }
                                                                >
                                                                    <LaunchIcon />
                                                                </IconButton>
                                                            
                                                    }

                                                </TableCell>

                                            </TableRow>
                                        ))
                                    }                                     

                                    { 
                                        ( rows.length === 0 && !loading )
                                        ?   
                                            <TableRow style={{ height: 73 }}>

                                                <TableCell colSpan={7} align='center'> 

                                                    <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>
                                                    
                                                </TableCell>

                                            </TableRow>                     
                                        :
                                            loading
                                            &&
                                                <TableRow style={{ height: 73 }}>

                                                    <TableCell colSpan={7} align='center'> 

                                                        <CircularProgress size={26} />
                                                        
                                                    </TableCell>

                                                </TableRow>                     
                                    }

                                </TableBody>

                            </Table>
                            
                        </TableContainer>

                    </Grid>                        

                </Grid>

            </DialogContent>

            <DialogActions sx={ DialogActionsStyle }>
                <Button color='secondary' onClick={ cerrarDialog }>Cancelar</Button>
            </DialogActions>

        </Dialog>

    )
}